import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

interface MenuItem {
    label: string;
    url: string;
}

@Component({
    selector: 'oc-bms-client-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {
    public menuItems: MenuItem[] | undefined = [];

    public constructor(public activatedRoute: ActivatedRoute, private readonly router: Router) {}

    public ngOnInit(): void {
        this.router.events.subscribe(() => (this.menuItems = this.createBreadcrumbs(this.activatedRoute.root)));
    }

    private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] | undefined {
        const children: ActivatedRoute[] = route.children;

        children.forEach((child) => {
            const routeURL: string = child.snapshot.url.map((segment) => segment.path).join('/');
            if (routeURL !== '') {
                url += `/${routeURL}`;
            }

            const label = child.snapshot.title;
            if (label && breadcrumbs.findIndex((e) => e.url === url) === -1) {
                breadcrumbs.push({ label, url });
            }

            return this.createBreadcrumbs(child, url, breadcrumbs);
        });

        return breadcrumbs;
    }
}
